import React, { Fragment, useState, useEffect, useCallback } from 'react';

import { toastr } from 'react-redux-toastr';
import MenuVariaveis from '../../MenuVariaveis';

export const valueRegex = /data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+);base64,.*/;

export default ({ doUpdateItem, item }) => {
  const [variableUrl, setVariableUrl] = useState('');
  const [mediaIsOpen, setMediaIsOpen] = useState(true);

  useEffect(() => {
    if (item) {
      setVariableUrl(item.variableUrl);
    }
  }, [item]);

  const handleSelectVariavel = useCallback(
    (name, value, variavel, setState) => {
      const newValue = `${value} {${variavel}}`;
      setState(newValue);
      doUpdateItem({ [name]: newValue });
    },
    []
  );

  const handleEditVariableUrl = (value) => {
    if (valueRegex.test(value)) {
      setVariableUrl('');
      toastr.error('Erro', 'Valores em Base64 não são permitidos no criador');
      doUpdateItem({
        variableUrl: '',
      });
    } else if (!valueRegex.test(value)) {
      setVariableUrl(value);
      doUpdateItem({
        variableUrl: value,
      });
    }
  };

  return (
    <Fragment>
      <p
        className="pointer handler-title"
        onClick={() => setMediaIsOpen(!mediaIsOpen)}
      >
        Mídia
        <img
          alt=""
          className={`seta-expander ${!mediaIsOpen ? 'arrow-rotation' : ''}`}
          src="/assets/images/icons/seta_close.svg"
        />
      </p>

      {mediaIsOpen && (
        <MenuVariaveis
          onSelect={(variavel) =>
            handleSelectVariavel(
              'variableUrl',
              variableUrl,
              variavel,
              setVariableUrl
            )
          }
          buttonRight="27px"
          buttonBottom="25px"
          id={`bloco-${item._id}-configuracao`}
          isTooltip
        >
          <div className="common-form-group">
            <label>URL</label>
            <input
              placeholder="Adicionar URL"
              type="url"
              id="api-urlEndpoint"
              name="urlEndpoint"
              className="form-control mt-1"
              onChange={(e) => handleEditVariableUrl(e.target.value)}
              value={variableUrl}
            />
          </div>
        </MenuVariaveis>
      )}
    </Fragment>
  );
};
